<template>
  <h3 style="color:red;" class="text-center mt-4" v-if="isDemo">
    <p>
      Демонстрационный режим.
    </p>
    <p>
      Зарегистрированный цифровой отпечаток файла будет удалён через 1 сутки.
    </p>
  </h3>
</template>
<script>
import { isDemo } from '../environment'

export default {
  name: 'DemoLabel',
  props: {
    isDemo: {
      type: Boolean,
      default: () => isDemo()
    }
  },
}
</script>